<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM6 8.5H7.52344L6.94336 10.6777L6.91309 10.8262C6.80731 11.5655 7.38057 12.2497 8.15039 12.25H10V10.75H8.47559L9.22461 7.94336C9.28465 7.71822 9.23668 7.47774 9.09473 7.29297C8.95277 7.10824 8.73298 7 8.5 7H6V8.5ZM8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4Z"
    fill="currentColor"
  />
</svg>
